import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { getContratantesColectivos } from '../../../services/supabase/contratantesColectivosService';

export default function ContratantesColectivosList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const data = await getContratantesColectivos();
        setItems(data || []);
      } catch (e) {
        console.error('Error cargando contratantes colectivos', e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const filtered = items.filter(i =>
    (i?.nombre_razon_social || '').toLowerCase().includes(search.toLowerCase()) ||
    (i?.rut || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Contratantes Colectivos</h1>
        <Link to="/product_config/contratantes/new">
          <Button>Nuevo</Button>
        </Link>
      </div>

      <div className="flex gap-3">
        <Input
          placeholder="Buscar por razón social o RUT..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="max-w-md"
        />
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Listado</CardTitle>
        </CardHeader>
        <CardContent>
          {loading ? (
            <div className="text-sm text-muted-foreground">Cargando...</div>
          ) : filtered.length ? (
            <div className="space-y-2">
              {filtered.map(item => (
                <div key={item.id} className="flex items-center justify-between border rounded p-3">
                  <div className="space-y-0.5">
                    <div className="font-medium">{item.nombre_razon_social}</div>
                    <div className="text-sm text-muted-foreground">{item.rut || 'Sin RUT'}</div>
                  </div>
                  <Link to={`/product_config/contratantes/edit/${item.id}`}>
                    <Button variant="outline" size="sm">Editar</Button>
                  </Link>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-sm text-muted-foreground">No hay registros</div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}